import type { ReactNode } from 'react';

// The page container. The old per-page header BAND (icon + tabs + date + actions)
// is gone — the global top bar owns page chrome, and tabs/filters live in the
// Split-Row toolbar. But each page keeps a plain title heading, top-left, so you
// always know where you are. This is just the padded main-column wrapper.
export function Page({ title, aside, children }: { title?: string; aside?: ReactNode; children: ReactNode }) {
  return (
    <div className="page-main">
      {/* A page that carries something beside its title (the Daily's stack) keeps the title row at
          40px, so the row costs no height either way (notifications-daily-stack AC1). */}
      {title && aside ? (
        <div className="page-titlerow">
          <h1 className="page-heading">{title}</h1>
          {aside}
        </div>
      ) : (
        title && <h1 className="page-heading">{title}</h1>
      )}
      {children}
    </div>
  );
}
